import {
	IVIPCertificatePipelineWork,
	IVIPCertificatePipelineTests,
	VIPCertificatePipelineType,
	createCertificatePipelineTests,
	checkCertificatePipelineTests,
} from "@/loader";


export interface IVIPCertificatePipeline {
	type?: VIPCertificatePipelineType;
	rehab_type?: VIPCertificatePipelineType;
	armor?: string;
	drawdownMaterial?: string;
	works: IVIPCertificatePipelineWork[];
	tests: IVIPCertificatePipelineTests;
}

export function createCertificatePipeline(): IVIPCertificatePipeline {
	return {
		type: VIPCertificatePipelineType.none,
		rehab_type: VIPCertificatePipelineType.none,
		armor: "",
		drawdownMaterial: "",
		works: [],
		tests: createCertificatePipelineTests(),
	};
}

export function checkCertificatePipeline(data: IVIPCertificatePipeline) {
	if (data.type === undefined) {
		data.type = VIPCertificatePipelineType.none;
	}
	if (data.rehab_type === undefined) {
		data.rehab_type = VIPCertificatePipelineType.none;
	}
	if (data.armor === undefined) {
		data.armor = "";
	}
	if (data.drawdownMaterial === undefined) {
		data.drawdownMaterial = "";
	}
	if (data.works === undefined) {
		data.works = [];
	}
	if (data.tests === undefined) {
		data.tests = createCertificatePipelineTests();
	} else {
		checkCertificatePipelineTests(data.tests);
	}
}
